import type { ReactNode } from "react";
import Modal from "react-modal";
import { AreaButton, ButtonVariant } from "../teacherArea/AreaButton";

interface PopupAction {
    label: string;
    accessibilityLabel: string;
    onClick: () => void;
    "data-testid"?: string;
}

interface OnlineTestPopupProps {
    children: ReactNode;
    primaryAction: PopupAction;
    isOpen: boolean;
    onClose: () => void;
    ariaLabel: string;
    "data-testid"?: string;

    secondaryAction?: PopupAction;
}

Modal.setAppElement("#root");

const OnlineTestPopup = (props: OnlineTestPopupProps) => {
    const renderSecondaryButton = () => {
        if (!props.secondaryAction) return null;

        return (
            <div
                className="grid"
                data-testid={props.secondaryAction["data-testid"]}
            >
                <AreaButton
                    variant={ButtonVariant.SECONDARY}
                    role="button"
                    onClick={props.secondaryAction.onClick}
                    aria-label={props.secondaryAction.accessibilityLabel}
                >
                    {props.secondaryAction.label}
                </AreaButton>
            </div>
        );
    };

    const renderPrimaryButton = () => {
        return (
            <div
                className="grid"
                data-testid={props.primaryAction["data-testid"]}
            >
                <AreaButton
                    variant={ButtonVariant.PRIMARY}
                    role="button"
                    onClick={props.primaryAction.onClick}
                    aria-label={props.primaryAction.accessibilityLabel}
                >
                    {props.primaryAction.label}
                </AreaButton>
            </div>
        );
    };

    return (
        <Modal
            isOpen={props.isOpen}
            onRequestClose={props.onClose}
            contentLabel={props.ariaLabel}
            style={{
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.4)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 100,
                },
                content: {
                    position: "unset",
                    margin: "1rem",
                    border: "none",
                    borderRadius: "24px",
                    padding: "1.5rem",
                    maxWidth: "600px",
                    width: "100%",
                    inset: "unset",
                },
            }}
        >
            <div
                className="flex flex-col gap-m"
                data-testid={props["data-testid"]}
            >
                {props.children}
            </div>
            <div className="flex flex-col gap-xs mt-m">
                {renderSecondaryButton()}
                {renderPrimaryButton()}
            </div>
        </Modal>
    );
};

export default OnlineTestPopup;
